import React, { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import Modal from "../../../../../layout/modal";
import { BASE_ITEMS, PROFILE_KEY, defaultSelection, descendantKeys, flatten, visibleItems } from "./tree";

function ExtractModal({ show, person, onOk, onCancel }) {
  const items = useMemo(() => visibleItems(BASE_ITEMS, person?.flags || 0), [person]);
  const selectableKeys = useMemo(() => flatten(items).filter((item) => !item.required).map((item) => item.key), [items]);
  const [selected, setSelected] = useState({});

  useEffect(() => {
    if (!show) return;
    setSelected(defaultSelection(items));
  }, [show, items]);

  const isChecked = (key) => key === PROFILE_KEY || Boolean(selected[key]);

  const onToggle = (item) => {
    if (item.key === PROFILE_KEY) return;
    const checked = !isChecked(item.key);
    const keys = [item.key, ...descendantKeys(item)];
    setSelected((prev) => ({
      ...prev,
      ...keys.reduce((memo, key) => {
        memo[key] = checked;
        return memo;
      }, {})
    }));
  };

  const setAll = (checked) => {
    setSelected({
      ...selectableKeys.reduce((memo, key) => {
        memo[key] = checked;
        return memo;
      }, {}),
      [PROFILE_KEY]: true
    });
  };

  const handleOk = () => {
    onOk?.({
      selection: {
        ...selected,
        [PROFILE_KEY]: true
      }
    });
  };

  const renderItem = (item, depth = 0, parentChecked = true) => {
    const checked = parentChecked && isChecked(item.key);
    return (
    <div key={item.key} className={depth === 0 ? "mb-2" : "mt-1"} style={{ marginLeft: depth * 22 }}>
      <Form.Check
        id={`extract-${item.key}`}
        type="checkbox"
        label={item.required ? `${item.caption} (required)` : item.caption}
        checked={checked}
        disabled={item.required || !parentChecked}
        onChange={() => onToggle(item)}
      />
      {item.children?.map((child) => renderItem(child, depth + 1, checked))}
    </div>
    );
  };

  return (
    <Modal
      show={show}
      title="Export"
      body="Choose what to include in the export."
      size="lg"
      buttons={[
        {
          caption: "export",
          onClick: handleOk,
          variant: "primary",
          enabled: true,
          display: true
        },
        {
          default: true,
          caption: "cancel",
          onClick: onCancel,
          variant: "primary",
          enabled: true,
          display: true
        }
      ]}
    >
      <div className="d-flex gap-3 mb-3 mt-3">
        <button type="button" className="btn btn-link p-0" onClick={() => setAll(true)}>
          check all
        </button>
        <button type="button" className="btn btn-link p-0" onClick={() => setAll(false)}>
          uncheck all
        </button>
      </div>
      <div className="border rounded p-3">
        {items.map((item) => renderItem(item))}
      </div>
    </Modal>
  );
}

export default ExtractModal;
